import { render } from "./MarketplaceSkusPriceImportModal.vue?vue&type=template&id=3bfe4a5b&ts=true&lang=pug"
import script from "./MarketplaceSkusPriceImportModal.vue?vue&type=script&lang=ts"
export * from "./MarketplaceSkusPriceImportModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__